export default function SearchIsActive(filters, search) {
  return Object.keys(search).some((d, i) => filters.map((s, _i) => s[0] ).includes(d) )  
}